var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4878_21833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5748 5.96282L14.0373 2.42532C13.6858 2.07422 13.2092 1.87695 12.7123 1.87695C12.2155 1.87695 11.7389 2.07422 11.3873 2.42532L2.42483 11.3878C2.07373 11.7394 1.87646 12.216 1.87646 12.7128C1.87646 13.2097 2.07373 13.6863 2.42483 14.0378L5.25617 16.8753H3.74992C3.52662 16.8753 3.3203 16.9945 3.20863 17.1878C3.09698 17.3812 3.09698 17.6194 3.20863 17.8128C3.32029 18.0062 3.5266 18.1253 3.74992 18.1253H16.2499C16.4732 18.1253 16.6795 18.0062 16.7912 17.8128C16.9029 17.6194 16.9029 17.3812 16.7912 17.1878C16.6795 16.9945 16.4732 16.8753 16.2499 16.8753H9.31242L17.5749 8.61282C17.926 8.26125 18.1233 7.78469 18.1233 7.28782C18.1233 6.79095 17.926 6.31439 17.5749 5.96282H17.5748ZM7.28117 16.8753C7.11723 16.8746 6.96007 16.8096 6.84367 16.6941L3.30617 13.1566C3.18976 13.0394 3.1244 12.8811 3.1244 12.7159C3.1244 12.5508 3.18976 12.3924 3.30617 12.2753L5.47483 10.1066L9.8935 14.5253L7.72483 16.694C7.60843 16.8095 7.45127 16.8745 7.28733 16.8752L7.28117 16.8753ZM16.6937 7.72532L10.775 13.644L6.35633 9.22532L12.275 3.30665C12.3921 3.19025 12.5505 3.12489 12.7156 3.12489C12.8807 3.12489 13.0391 3.19025 13.1563 3.30665L16.6938 6.87532C16.8009 6.99088 16.8605 7.1427 16.8605 7.30032C16.8605 7.45794 16.8009 7.60975 16.6938 7.72532H16.6937Z",
    fill: "#1B5AF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4878_21833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.f2c065d9.svg";
export { ForwardRef as ReactComponent };